import React, { Fragment } from 'react';
import { Form } from 'react-bootstrap';

const sanitizeValue = (value) => {
    return value
        .replace(/[^0-9.\-]/g, '')
        .replace(/(?!^)-/g, '')
        .replace(/(\.\d*)\./g, '$1');
};

const onKeyDown = (e) => {
    const blocked = ['e', 'E', '+', 'Exp', ','];
    if (blocked.includes(e.key)) {
        e.preventDefault();
    }
};

const onInput = (e) => {
    const input = e.target;
    const sanitized = sanitizeValue(input.value);
    if (input.value !== sanitized) {
        input.value = sanitized;
    }
};

const onPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text');
    const sanitized = sanitizeValue(pasted);
    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const current = input.value;
    const newValue = sanitizeValue(current.slice(0, start) + sanitized + current.slice(end));
    input.value = newValue;
    input.dispatchEvent(new Event('input', { bubbles: true }));
};

export const numberFieldHandler = {
    onKeyDown,
    onInput,
    onPaste,
    sanitizeValue,
};

const NumberFieldProperties = ({ element, register, errors, watch }) => {
    const sharedProps = (name, defaultValue, registerOptions = {}) => ({
        name,
        type: 'number',
        defaultValue,
        ref: register(registerOptions),
        onWheel: (e) => e.currentTarget.blur(),
        onKeyDown: onKeyDown,
        onInput: onInput,
        onPaste: onPaste,
        step: 'any',
    });

    const minValue = watch('fieldProperties.minValue');
    const maxValue = watch('fieldProperties.maxValue');

    return (
        <Fragment>
            <b>Entry Limits</b>
            <span className="text-muted ml-4">(Limit the minimum or maximum value allowed for this field)</span>
            <Form.Group controlId="minMaxValues" className="mt-2 d-flex flex-row " style={{ alignItems: 'center' }}>
                <Form.Label className="mr-2">Minimum:</Form.Label>
                <Form.Control
                    {...sharedProps('fieldProperties.minValue', (element?.fieldProperties || {})?.minValue, {
                        validate: (value) =>
                            !value ||
                            !maxValue ||
                            Number(maxValue) > Number(value) ||
                            'Maximum must be greater than Minimum',
                    })}
                />
                <Form.Label className="ml-4 mr-2">Maximum:</Form.Label>
                <Form.Control
                    {...sharedProps('fieldProperties.maxValue', (element?.fieldProperties || {})?.maxValue, {
                        validate: (value) =>
                            !value ||
                            !minValue ||
                            Number(value) > Number(minValue) ||
                            'Maximum must be greater than Minimum',
                    })}
                />
            </Form.Group>
            {errors?.fieldProperties?.maxValue && (
                <Form.Text className="text-danger">{errors.fieldProperties.maxValue.message}</Form.Text>
            )}
        </Fragment>
    );
};

export default NumberFieldProperties;
